import { createSelector } from 'reselect';

export const usersStateSelector = state => state.users?.users;

export const usersSelector = createSelector(usersStateSelector, usersState => usersState);

export const usersListSelector = createSelector(
    usersStateSelector,
    usersState => usersState?.users || []
);
